import React from 'react'

import type {FormContext} from 'src/shared/types'

const UserSettingsContext = React.createContext<FormContext | null>(null)

export const useUserSettingsContext = () => {
  const context = React.useContext(UserSettingsContext)

  if (context === null) {
    throw new Error('useUserSettings must be used within a UserSettingsProvider')
  }

  return context
}

type Context = React.PropsWithChildren<{
  value: FormContext
}>

const UserSettingsProvider: React.FC<Context> = ({children, value}) => {
  return <UserSettingsContext.Provider value={value}>{children}</UserSettingsContext.Provider>
}

UserSettingsProvider.displayName = 'UserSettingsContext'

export default UserSettingsProvider
